import { BothModifiedConflict } from "@common/dto/financialAccount/mergeFinancialAccounts/both-modified-conflict.dto";
import { Transaction } from "@common/types/transaction";
import classNames from "classnames";
import gridTableStyles from "@design-system/Tables/GridTable/GridTableBase.module.scss";
import { Radio, RadioGroup } from "@design-system/Radio/Radio";
import { TransactionToMerge } from "./TransactionToMerge";
import styles from "./BothModifiedConflicts.module.scss";

interface Props {
    conflict: BothModifiedConflict;
    resolutions: number[];
    onResolve: (
        conflict: BothModifiedConflict,
        transaction: Transaction,
    ) => void;
}

export const BothModifiedConflictResolving: React.FC<Props> = ({
    conflict,
    resolutions,
    onResolve,
}) => {
    const destinationValue = String(conflict.transactionFromDestination.id);
    const mergedValue = String(conflict.transactionFromMerged.id);
    let selectedValue = "";
    if (resolutions.includes(conflict.transactionFromDestination.id)) {
        selectedValue = destinationValue;
    } else if (resolutions.includes(conflict.transactionFromMerged.id)) {
        selectedValue = mergedValue;
    }

    return (
        <RadioGroup
            name={`both-modified-${conflict.transactionFromDestination.id}`}
            aria-label="Transaction to keep"
            value={selectedValue}
            onValueChange={(value) => {
                if (value === destinationValue) {
                    onResolve(conflict, conflict.transactionFromDestination);
                } else if (value === mergedValue) {
                    onResolve(conflict, conflict.transactionFromMerged);
                }
            }}
            className={classNames(gridTableStyles.gridTable, styles.table)}
        >
            <div className={gridTableStyles.headerRow}>
                <div>Select</div>
                <div className={styles.headerCell}>In destination</div>
            </div>
            <TransactionToMerge
                transaction={conflict.transactionFromDestination}
                prepend={
                    <div>
                        <Radio value={destinationValue} />
                    </div>
                }
                onClick={() =>
                    onResolve(conflict, conflict.transactionFromDestination)
                }
                className={styles.conflictRow}
            />
            <div className={gridTableStyles.headerRow}>
                <div className={styles.headerCell}>To merge</div>
            </div>
            <TransactionToMerge
                transaction={conflict.transactionFromMerged}
                prepend={
                    <div>
                        <Radio value={mergedValue} />
                    </div>
                }
                onClick={() =>
                    onResolve(conflict, conflict.transactionFromMerged)
                }
                className={styles.conflictRow}
            />
        </RadioGroup>
    );
};
